import { gql } from '@apollo/client'

import { FRAGMENT as COURSE_CHIP_FRAGMENT } from '../CourseChip'

export default gql`
  fragment CourseCollectionCardComponent on ProductCollection {
    id
    title
    description
    image {
      url
    }
    price {
      currencyCode
      value
    }
    fullPrice {
      currencyCode
      value
    }
    slug
    variants {
      nodes {
        id
        product {
          ... on ProductCourse {
            ...CourseChipComponent
          }
        }
      }
    }
  }

  ${COURSE_CHIP_FRAGMENT}
`
